export enum QueryKeys {
  KEY = "key",
  SECRET = "secret",

  PAGE_SIZE = "pageSize",
  PAGE_INDEX = "pageIndex",
  FILTER = "filter",
  ORDER_BY = "orderby",
  THEN_by = "thenby",
}
